import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 运价详情-附加信息
export function queryOpenPriceFclExtra(data) {
  return request({
    url: URL.price.priceFclExtra.queryOpenPriceFclExtra,
    method: 'post',
    data
  })
}

// 整箱附加信息维护-已发布列表查询
export function queryEffectivePriceFclExtra(data) {
  return request({
    url: URL.price.priceFclExtra.queryEffectivePriceFclExtra,
    method: 'post',
    data
  })
}

// 整箱附加信息维护-待审核列表查询
export function queryPendingPriceFclExtra(data) {
  return request({
    url: URL.price.priceFclExtra.queryPendingPriceFclExtra,
    method: 'post',
    data
  })
}
// 整箱附加信息维护-保存
export function savePriceFclExtra(data) {
  return request({
    url: URL.price.priceFclExtra.savePriceFclExtra,
    method: 'post',
    data
  })
}
// 整箱附加信息维护-批量删除
export function deletePriceFclExtras(data) {
  return request({
    url: URL.price.priceFclExtra.deletePriceFclExtras,
    method: 'post',
    data
  })
}
// 整箱附加信息维护-批量审核
export function approvePriceFclExtras(data, params) {
  return request({
    url: URL.price.priceFclExtra.approvePriceFclExtras,
    method: 'post',
    data,
    params
  })
}
